<a class="skip-link" href="#main-content">Saltar al contenido principal</a>
<app-site-header />
<main #mainContent id="main-content" tabindex="-1">
  <router-outlet />
</main>
<app-site-footer />
<a
  class="whatsapp-link"
  href="https://wa.me/34655340607"
  target="_blank"
  rel="noopener noreferrer"
  aria-label="Contactar con ATSIestudio por WhatsApp (se abre en una pestaña nueva)"
>
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path
      d="M12.04 2a9.84 9.84 0 0 0-8.5 14.78L2 22l5.36-1.5A9.95 9.95 0 1 0 12.04 2Zm0 17.9a8.2 8.2 0 0 1-4.18-1.14l-.3-.18-3.18.89.85-3.1-.2-.32A8.15 8.15 0 1 1 12.04 19.9Zm4.47-6.1c-.24-.12-1.45-.71-1.67-.8-.23-.08-.39-.12-.55.13-.16.24-.63.79-.77.95-.14.17-.29.19-.53.07-.25-.13-1.03-.38-1.97-1.22a7.4 7.4 0 0 1-1.36-1.7c-.14-.25-.02-.38.1-.5.11-.11.25-.29.37-.43.12-.14.16-.24.24-.41.08-.16.04-.3-.02-.43-.06-.12-.55-1.32-.75-1.81-.2-.48-.4-.41-.55-.42h-.47c-.16 0-.43.06-.65.3-.22.25-.85.84-.85 2.04s.87 2.36 1 2.52c.12.17 1.72 2.63 4.17 3.69.58.25 1.03.4 1.39.51.58.19 1.11.16 1.53.1.47-.07 1.45-.6 1.65-1.17.2-.58.2-1.08.14-1.18-.06-.1-.22-.16-.47-.28Z"
    />
  </svg>
  <span>WhatsApp</span>
</a>
<app-consent-preferences />
